import { VOUILabelList } from "./DataStructure.js";

export type LanguageCode = "de" | "en";
export class Language {

    public static GERMAN: LanguageCode = "de";
    public static ENGLISH: LanguageCode = "en";
    public static onChange = e5.Signal.create<[LanguageCode]>();

    private static _current: LanguageCode = "de";
    private static _uiLabels: VOUILabelList[];

    public static init(uiLabels: VOUILabelList[], language: LanguageCode = "de"): void {
        Language._current = language;
        Language._uiLabels = uiLabels;
        document.body.setAttribute("data-language", language);
        document.documentElement.setAttribute("lang", language);

        // $("body").on("pointerdown", ".language-button[data-lang=de]", () => {
        //     Language.current = "de";
        // });

        // $("body").on("pointerdown", ".language-button[data-lang=en]", () => {
        //     Language.current = "en";
        // });

        document.addEventListener("keyup", (e) => {
            if (e.ctrlKey && e.keyCode == 76) {
                Language.current = Language.current == "de" ? "en" : "de";
            }
        });
    }

    public static get current(): LanguageCode {
        return Language._current;
    }

    public static set current(language: LanguageCode) {
        if (Language._current == language)
            return;
        Language._current = language;

        document.body.setAttribute("data-language", language);
        document.documentElement.setAttribute("lang", language);

        var fallbackLanguage = language == "de" ? "en" : "de";

        if (language == Language.ENGLISH) {
            $(".language-button[data-lang=de]").removeClass("selected");
            $(".language-button[data-lang=en]").addClass("selected");
        }
        else if (language == Language.GERMAN) {
            $(".language-button[data-lang=en]").removeClass("selected");
            $(".language-button[data-lang=de]").addClass("selected");
        }
        document.querySelectorAll("[data-en]").forEach((element: Element) => {
            var newText = element.getAttribute("data-" + language);
            if (!newText && fallbackLanguage) {
                newText = element.getAttribute("data-" + fallbackLanguage);
            }

            if (!newText)
                newText = element.getAttribute("data-fallback");

            var attr = element.getAttribute("data-lang-attr");
            if (!attr) {
                element.innerHTML = newText;
            }
            else
                element.setAttribute(attr, newText);
        });

        Language.onChange.dispatch(language);
    }

    public static label(element: HTMLElement, uiLabelKey: string, attr: string = "", fallback: string = ""): boolean {
        return this.apply(element,
            Language.translate(uiLabelKey, Language.GERMAN),
            Language.translate(uiLabelKey, Language.ENGLISH),
            attr,
            fallback);
    }

    public static apply(element: HTMLElement, german: string, english: string, attr: string = "", fallback: string = ""): boolean {
        var newText = Language.current == "de" ? german || english : english || german;
        if (!newText)
            newText = fallback;
        element.setAttribute("data-de", german);
        element.setAttribute("data-en", english);
        element.setAttribute("data-fallback", fallback);
        if (attr)
            element.setAttribute("data-lang-attr", attr);
        if (!attr)
            element.innerHTML = newText;
        else
            element.setAttribute(attr, newText);
        return Boolean(newText);
    }

    public static translate(uiLabelKey: string, language: LanguageCode, fallback: string = ""): string {
        var spl = uiLabelKey.split(".");
        var title = spl[0];
        uiLabelKey = spl[1];
        for (var list of Language._uiLabels) {
            if (list.title == title) {
                for (var label of list.ui_labels) {
                    if (label.ui_label_key == uiLabelKey) {
                        var res = language == Language.GERMAN ? label.ui_label_de : label.ui_label_en;
                        return res || fallback;
                    }
                }
            }
        }
        //return fallback || key;
        return fallback;
    }
}